// Default feature redirect component

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/sdk/auth/hooks';
import { NoFeatureAccess } from '@/modules/auth/components/NoFeatureAccess';
import { firstFeaturePath } from '@/modules/auth/featurePaths';

/**
 * Component that redirects to the first available feature for the current organization
 * Used as the default route when accessing /dashboard/:orgId
 */
export function DefaultFeatureRedirect() {
  const { currentOrg, user } = useAuth();

  if (!currentOrg) {
    return <Navigate to="/client/orgs" replace />;
  }

  // Super admins reach every page, whatever the org has enabled.
  if (user?.is_super_admin) {
    return <Navigate to="workflows" replace />;
  }

  const featurePath = firstFeaturePath(currentOrg.feature_access || []);
  if (!featurePath) {
    return <NoFeatureAccess orgName={currentOrg.name} reason="org" />;
  }

  // Redirect to first available feature
  return <Navigate to={featurePath} replace />;
}
